import './styles.css';

export default function ElementsTable({
  tableColumnHeader,
  tableHeaders,
  tableData,
  isDataLoading,
  bigCells = false,
  // Hide just the per-data-column header text (keeping the
  // tableColumnHeader cell). Used by the principles instructor modal
  // where the column-key label ("Impact on Profits") shouldn't render
  // but the question-column label ("Business Activity") should.
  hideColumnHeaders = false,
}) {
  const noDataTitle = isDataLoading ? 'Loading...' : 'No data available';
  return (
    <div className="questions-transactions-table-container">
      {
        (tableHeaders && tableData?.length > 0 && !isDataLoading) ? (
          <table className="questions-transactions-table">
            <thead>
              <tr>
                <th>{tableColumnHeader}</th>
                {tableHeaders.map((header, index) => (
                  <th key={index}>{hideColumnHeaders ? '' : header}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {tableData.map((row, rowIndex) => (
                <tr key={rowIndex}>
                  <td>{row.question}</td>
                  {tableHeaders.map((header, index) => (
                    <td
                      key={index}
                      style={{
                        backgroundColor: row[header]?.background,
                      }}
                      className="questions-transactions-item-cell"
                    >
                      {
                        row[header] &&
                          <div className={`question-transaction-item-container${bigCells ? ' full-height' : ''}`}>
                            {row[header].map((item, index) => (
                              <div 
                                key={index}
                                style={{ backgroundColor: item.background }}
                                className="questions-transactions-item"
                                dangerouslySetInnerHTML={{ __html: item.value }}
                                title={item.explanation}
                              />
                            ))}
                          </div>
                      }
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        ) : (
          <h4>{noDataTitle}</h4>
        )
      }
    </div>
  );
}
